'use client';

import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    businessEmail: '',
    phone: '',
    jobTitle: '',
    organizationName: '',
    message: '',
  });

  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    await new Promise((r) => setTimeout(r, 1200));
    setSubmitting(false);
    setSubmitted(true);
  };

  return (
    <main style={{ backgroundColor: '#fff' }}>

      {/* ===== HERO HEADER BAND ===== */}
      <div
        style={{
          background: '#db532a',
          paddingTop: '3.5rem',
          paddingBottom: '4.5rem',
          textAlign: 'center',
        }}
      >
        <h1
          className="fw-bold text-white mb-2"
          style={{
            fontSize: 'clamp(2.2rem, 5vw, 3.25rem)',
            letterSpacing: '-0.025em',
            lineHeight: 1.2,
          }}
        >
          Get in touch
        </h1>
        <p
          className="text-white mb-0"
          style={{ opacity: 0.95, fontSize: '1.05rem', fontWeight: 400 }}
        >
          We&#39;ll love to hear from you!
        </p>
      </div>

      {/* ===== FORM SECTION ===== */}
      <section
        style={{
          backgroundColor: '#f7e1dd',
          paddingTop: '3.5rem',
          paddingBottom: '5rem',
        }}
      >
        <div className="container px-3" style={{ maxWidth: '600px' }}>
          {submitted ? (
            <div
              className="bg-white text-center"
              style={{
                borderRadius: '16px',
                padding: '3.5rem 2rem',
                boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
              }}
            >
              <div
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: '50%',
                  backgroundColor: '#db532a',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1.25rem',
                }}
              >
                <i className="bi bi-check-lg text-white" style={{ fontSize: '1.6rem' }} />
              </div>
              <h2
                className="fw-bold mb-2"
                style={{ fontSize: '1.5rem', color: '#111827' }}
              >
                Message sent!
              </h2>
              <p style={{ color: '#6b7280', fontSize: '0.97rem' }}>
                Thank you for reaching out. We&rsquo;ll get back to you as soon as possible.
              </p>
              <button
                className="btn mt-2"
                style={{
                  backgroundColor: '#db532a',
                  color: '#fff',
                  borderRadius: '50px',
                  padding: '0.6rem 2rem',
                  fontWeight: 600,
                  border: 'none',
                }}
                onClick={() => {
                  setSubmitted(false);
                  setFormData({
                    firstName: '',
                    lastName: '',
                    businessEmail: '',
                    phone: '',
                    jobTitle: '',
                    organizationName: '',
                    message: '',
                  });
                }}
              >
                Send another message
              </button>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="bg-white"
              style={{
                borderRadius: '16px',
                padding: '2.25rem 2.5rem 2.5rem',
                boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
              }}
            >
              {/* First name / Last name */}
              <div className="row g-3 mb-3">
                <div className="col-12 col-sm-6">
                  <label htmlFor="firstName" style={labelStyle}>
                    First name
                  </label>
                  <input
                    id="firstName"
                    name="firstName"
                    type="text"
                    placeholder="First name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    className="form-control"
                    style={inputStyle}
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <label htmlFor="lastName" style={labelStyle}>
                    Last name
                  </label>
                  <input
                    id="lastName"
                    name="lastName"
                    type="text"
                    placeholder="Last name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    className="form-control"
                    style={inputStyle}
                  />
                </div>
              </div>

              {/* Business email */}
              <div className="mb-3">
                <label htmlFor="businessEmail" style={labelStyle}>
                  Business email
                </label>
                <input
                  id="businessEmail"
                  name="businessEmail"
                  type="email"
                  placeholder="Business email"
                  value={formData.businessEmail}
                  onChange={handleChange}
                  required
                  className="form-control"
                  style={inputStyle}
                />
              </div>

              {/* Phone */}
              <div className="mb-3">
                <label htmlFor="phone" style={labelStyle}>
                  Phone
                </label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  placeholder="Phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="form-control"
                  style={inputStyle}
                />
              </div>

              {/* Job title / Organization name */}
              <div className="row g-3 mb-3">
                <div className="col-12 col-sm-6">
                  <label htmlFor="jobTitle" style={labelStyle}>
                    Job title
                  </label>
                  <input
                    id="jobTitle"
                    name="jobTitle"
                    type="text"
                    placeholder="Job title"
                    value={formData.jobTitle}
                    onChange={handleChange}
                    className="form-control"
                    style={inputStyle}
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <label htmlFor="organizationName" style={labelStyle}>
                    Organization name
                  </label>
                  <input
                    id="organizationName"
                    name="organizationName"
                    type="text"
                    placeholder="Organization name"
                    value={formData.organizationName}
                    onChange={handleChange}
                    className="form-control"
                    style={inputStyle}
                  />
                </div>
              </div>

              {/* Message */}
              <div className="mb-4">
                <label htmlFor="message" style={labelStyle}>
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  placeholder="Type your message here"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="form-control"
                  style={{ ...inputStyle, resize: 'vertical', minHeight: '120px' }}
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={submitting}
                className="btn w-100"
                style={{
                  backgroundColor: '#db532a',
                  color: '#fff',
                  borderRadius: '50px',
                  padding: '0.8rem',
                  fontWeight: 600,
                  fontSize: '1rem',
                  border: 'none',
                  letterSpacing: '0.01em',
                  transition: 'background 0.2s ease',
                  opacity: submitting ? 0.75 : 1,
                }}
              >
                {submitting ? 'Sending\u2026' : 'Send message'}
              </button>
            </form>
          )}
        </div>
      </section>

      {/* ===== INFO BAR ===== */}
      <section
        style={{
          backgroundColor: '#f7e1dd',
          borderTop: '1px solid rgba(219,83,42,0.15)',
          paddingTop: '2.5rem',
          paddingBottom: '3rem',
        }}
      >
        <div className="container px-3">
          <div
            className="d-flex flex-column flex-md-row align-items-start justify-content-center"
            style={{
              gap: 'clamp(2rem, 5vw, 4.5rem)',
              rowGap: '2rem',
              justifyContent: 'center',
            }}
          >

            {/* Office Hours */}
            <div style={{ flex: '0 0 auto' }}>
              <p style={infoHeadStyle}>Our Office Hours</p>
              <p style={infoTextStyle}>Monday&ndash;Friday</p>
              <p style={{ ...infoTextStyle, marginBottom: 0 }}>9:00 am to 5:00 pm</p>
            </div>

            {/* Head Office Address */}
            <div style={{ flex: '0 1 380px', maxWidth: '380px' }}>
              <p style={infoHeadStyle}>Head Office Address</p>
              <p style={{ ...infoTextStyle, marginBottom: 0 }}>
                3rd Floor, Sunny Motors Building, No. 3 Otunba Adedoyin,
                Ogungbe Crescent, Lekki 1, Lagos State.
              </p>
            </div>

            {/* Get In Touch */}
            <div style={{ flex: '0 0 auto' }}>
              <p style={infoHeadStyle}>Get In Touch</p>
              <a
                href="tel:+2348032003131"
                style={{
                  color: '#db532a',
                  fontSize: '0.95rem',
                  fontWeight: 500,
                  textDecoration: 'none',
                }}
              >
                +234 803 200 3131
              </a>
            </div>

          </div>
        </div>
      </section>

    </main>
  );
}

/* ─── Shared style objects ─────────────────────────────────────── */
const labelStyle = {
  display: 'block',
  fontSize: '0.82rem',
  fontWeight: 600,
  color: '#374151',
  marginBottom: '0.35rem',
};

const inputStyle = {
  borderRadius: '8px',
  border: '1.5px solid #e5e7eb',
  padding: '0.55rem 0.85rem',
  fontSize: '0.92rem',
  color: '#111827',
  backgroundColor: '#fff',
  width: '100%',
  outline: 'none',
  transition: 'border-color 0.18s ease',
};

const infoHeadStyle = {
  fontSize: '0.7rem',
  fontWeight: 700,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  color: '#db532a',
  marginBottom: '0.6rem',
};

const infoTextStyle = {
  fontSize: '0.93rem',
  color: '#374151',
  lineHeight: 1.6,
  marginBottom: '0.1rem',
};
